// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  text-align: center;
  padding: 24px 0 32px 0;
  max-width: 1200px;
  margin: 0 auto;
}
.heading > ds-text {
  display: block;
}
.heading > ds-text:first-of-type {
  padding-bottom: 16px;
}
.heading .buttons-header {
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 576px) {
  .heading .buttons-header {
    margin-top: 16px;
  }
}
.heading .buttons-header .button-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.heading .buttons-header .zurueck ds-icon {
  margin-right: 15px;
}
.heading .buttons-header .weiter ds-icon {
  margin-left: 15px;
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 128px;
}
.main-content .card-container {
  padding: 16px;
  background-color: #f5f5f5;
}
.main-content .card-container ds-card .card-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
@media (max-width: 576px) {
  .main-content .card-container ds-card .card-header.header-vertragsdetails {
    flex-direction: column;
  }
}
.main-content .card-container ds-card .card-header .umstellungsfaehigkeit {
  display: flex;
  align-items: center;
}
.main-content .card-container ds-card .card-header .umstellungsfaehigkeit .traffic-light {
  width: 16px;
  height: 16px;
  border-radius: 50px;
  margin-left: 24px;
}
.main-content .card-container ds-card .card-header .umstellungsfaehigkeit .traffic-light.traffic-light-green {
  background: #6ea318;
}
.main-content .card-container ds-card .card-header .umstellungsfaehigkeit .traffic-light.traffic-light-red {
  background: #be1413;
}
.main-content .card-container ds-card .card-header .umstellungsfaehigkeit .traffic-light.traffic-light-yellow {
  background: #e8b50e;
}
.main-content .card-container ds-card .card-content {
  display: flex;
  flex-direction: column;
}
.main-content .card-container ds-card .card-content .main-container {
  display: flex;
  margin-bottom: 24px;
  align-items: flex-start;
}
.main-content .card-container ds-card .card-content .main-container.spinner {
  justify-content: center;
  align-items: center;
  padding: 80px;
}
@media (max-width: 576px) {
  .main-content .card-container ds-card .card-content .main-container {
    justify-content: space-between;
  }
  .main-content .card-container ds-card .card-content .main-container.sparten-container {
    width: -moz-fit-content;
    width: fit-content;
    align-items: flex-start;
  }
  .main-content .card-container ds-card .card-content .main-container.display-column {
    flex-direction: column;
  }
  .main-content .card-container ds-card .card-content .main-container.display-column ds-text {
    margin-bottom: 8px;
  }
}
.main-content .card-container ds-card .card-content .main-container.user-input > ds-text {
  margin-top: 7px;
}
.main-content .card-container ds-card .card-content .main-container.user-input-big {
  align-items: center;
}
.main-content .card-container ds-card .card-content .main-container .col-content,
.main-content .card-container ds-card .card-content .main-container .col-label {
  width: 50%;
  display: flex;
}
.main-content .card-container ds-card .card-content .main-container .col-content.hinweise,
.main-content .card-container ds-card .card-content .main-container .col-label.hinweise {
  display: flex;
  flex-direction: column;
}
.main-content .card-container ds-card .card-content .main-container .col-content.hinweise .hinweis,
.main-content .card-container ds-card .card-content .main-container .col-label.hinweise .hinweis {
  margin-bottom: 8px;
}
.main-content .card-container ds-card .card-content .main-container .col-content.hinweise .hinweis:last-child,
.main-content .card-container ds-card .card-content .main-container .col-label.hinweise .hinweis:last-child {
  margin-bottom: 0px;
}
.main-content .card-container ds-card .card-content .main-container .col-content .ewe-content,
.main-content .card-container ds-card .card-content .main-container .col-label .ewe-content {
  display: flex;
  flex-direction: column;
}
.main-content .card-container ds-card .card-content .main-container .col-content .ewe-content.eweText,
.main-content .card-container ds-card .card-content .main-container .col-label .ewe-content.eweText {
  padding-right: 8px;
}
.main-content .card-container ds-card .card-content .main-container .col-content .ewe-content .ewe-info-btn,
.main-content .card-container ds-card .card-content .main-container .col-label .ewe-content .ewe-info-btn {
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  justify-items: center;
}
.main-content .card-container ds-card .card-content .main-container .col-content .text-color, .main-content .card-container ds-card .card-content .main-container .col-content .ewe-content .ewe-text-color,
.main-content .card-container ds-card .card-content .main-container .col-label .text-color,
.main-content .card-container ds-card .card-content .main-container .col-label .ewe-content .ewe-text-color {
  color: #be1413;
}
.main-content .card-container ds-card .card-content .main-container .col-content.flex-n,
.main-content .card-container ds-card .card-content .main-container .col-label.flex-n {
  align-items: center;
}
@media (max-width: 576px) {
  .main-content .card-container ds-card .card-content .main-container .col-content,
  .main-content .card-container ds-card .card-content .main-container .col-label {
    width: auto;
  }
  .main-content .card-container ds-card .card-content .main-container .col-content.flex-n,
  .main-content .card-container ds-card .card-content .main-container .col-label.flex-n {
    flex-direction: column;
    align-items: flex-start;
  }
}
.main-content .card-container ds-card .card-content .main-container .col-content .flexN-kontostand,
.main-content .card-container ds-card .card-content .main-container .col-label .flexN-kontostand {
  margin-left: 16px;
}
@media (max-width: 576px) {
  .main-content .card-container ds-card .card-content .main-container .col-content .flexN-kontostand,
  .main-content .card-container ds-card .card-content .main-container .col-label .flexN-kontostand {
    margin-left: 0;
    margin-top: 8px;
  }
}
.main-content .card-container ds-card .card-content .main-container .col-content ds-radio-button,
.main-content .card-container ds-card .card-content .main-container .col-label ds-radio-button {
  padding: 8px 66px 8px 12px;
}
.main-content .card-container ds-card .card-content .main-container .col-content.minderbeitrag-content,
.main-content .card-container ds-card .card-content .main-container .col-label.minderbeitrag-content {
  align-items: center;
}
.main-content .card-container ds-card .card-content .main-container .col-content.minderbeitrag-content .button,
.main-content .card-container ds-card .card-content .main-container .col-label.minderbeitrag-content .button {
  margin-left: 20px;
}
@media (max-width: 576px) {
  .main-content .card-container ds-card .card-content .main-container .col-content.minderbeitrag-content,
  .main-content .card-container ds-card .card-content .main-container .col-label.minderbeitrag-content {
    align-items: flex-start;
    flex-direction: column;
  }
  .main-content .card-container ds-card .card-content .main-container .col-content.minderbeitrag-content .button,
  .main-content .card-container ds-card .card-content .main-container .col-label.minderbeitrag-content .button {
    margin-left: 0;
    margin-top: 8px;
  }
}
.main-content .card-container ds-card .card-content .main-container .vertragnr-cont {
  display: flex;
}
.main-content .card-container ds-card .card-content .main-container .sparten-label {
  padding: 14px 0;
  width: 50%;
}
.main-content .card-container ds-card .card-content .main-container .sparten-content {
  padding: 0px 0px 14px 0px;
  border-top: 1px solid #dedede;
  border-bottom: 1px solid #dedede;
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .main-content .card-container ds-card .card-content .main-container .sparten-content {
    flex-direction: column;
    padding: 14px 0px 14px 0px;
  }
  .main-content .card-container ds-card .card-content .main-container .sparten-content .text-top {
    margin-right: 8px;
  }
}
.main-content .card-container ds-card .card-content .main-container .sparten-content-wrapper {
  margin-top: 14px;
}
@media (max-width: 768px) {
  .main-content .card-container ds-card .card-content .main-container .sparten-content-wrapper {
    margin-top: 0px;
  }
}
.main-content .card-container ds-card .card-content .main-container .sparten-content div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@media (max-width: 768px) {
  .main-content .card-container ds-card .card-content .main-container .sparten-content div {
    flex-direction: row;
    justify-content: space-between;
    margin-top: 0px;
  }
}
.main-content .card-container ds-card .card-content .main-container .sparten-content div .text-top {
  margin-bottom: 8px;
}
.main-content .buttons-container {
  display: flex;
  justify-content: space-between;
  padding: 8px 16px 16px 16px;
}
.main-content .buttons-container .col-delete {
  display: flex;
  align-items: center;
  margin-left: 24px;
}
.main-content .buttons-container .col-buttons {
  display: flex;
  align-items: center;
  margin-right: 24px;
}
@media (max-width: 576px) {
  .main-content .buttons-container .col-buttons {
    flex-direction: column;
  }
}
.main-content .buttons-container .col-buttons .button-secondary {
  margin-right: 24px;
}
@media (max-width: 576px) {
  .main-content .buttons-container .col-buttons .button-secondary {
    margin-right: 0;
    margin-bottom: 8px;
  }
}

.main-container.spinner {
  justify-content: center;
  align-items: center;
  padding: 180px;
}

.error-message {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}
.error-message ds-icon {
  margin-right: 10px;
}

.pre-wrap {
  white-space: pre-wrap;
}

.anschreibenInputWrapper {
  margin: 16px auto;
}

.anschreibenLineHint {
  text-align: right;
  display: block;
  padding-right: 8px;
  padding-top: 6px;
}

.flexN-Input {
  width: 80px;
}`, "",{"version":3,"sources":["webpack://./src/app/vertrag-details/vertrag-details.component.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAIA;EACE,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;AAHF;AAKE;EACE,cAAA;AAHJ;AAKI;EACE,oBAAA;AAHN;AAOE;EACE,eAAA;EACA,aAAA;EACA,8BAAA;AALJ;AAOI;EALF;IAMI,gBAAA;EAJJ;AACF;AAMI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAJN;AAQM;EACE,kBAAA;AANR;AAWM;EACE,iBAAA;AATR;;AAeA;EACE,iBAAA;EACA,cAAA;EACA,qBAAA;AAZF;AAcE;EACE,aAAA;EACA,yBC5BqB;ADgBzB;AAeM;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AAbR;AAgBU;EADF;IAEI,sBAAA;EAbV;AACF;AAgBQ;EACE,aAAA;EACA,mBAAA;AAdV;AAgBU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAdZ;AAgBY;EACE,mBCzBK;ADWnB;AAiBY;EACE,mBC/CG;ADgCjB;AAkBY;EACE,mBCvCI;ADuBlB;AAsBM;EACE,aAAA;EACA,sBAAA;AApBR;AAsBQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AApBV;AAsBU;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;AApBZ;AAuBU;EAXF;IAYI,8BAAA;EApBV;EAsBU;IACE,uBAAA;IAAA,kBAAA;IACA,uBAAA;EApBZ;EAuBU;IACE,sBAAA;EArBZ;EAuBY;IACE,kBAAA;EArBd;AACF;AA0BY;EACE,eAAA;AAxBd;AA4BU;EACE,mBAAA;AA1BZ;AA6BU;;EAEE,UAvIJ;EAwII,aAAA;AA3BZ;AA6BY;;EACE,aAAA;EACA,sBAAA;AA1Bd;AA4Bc;;EACE,kBAAA;AAzBhB;AA2BgB;;EACE,kBAAA;AAxBlB;AA6BY;;EACE,aAAA;EACA,sBAAA;AA1Bd;AA4Bc;;EACE,kBAAA;AAzBhB;AA+Bc;;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AA5BhB;AA+BY;;;EACE,cCxIG;AD6GjB;AA6BY;;EACE,mBAAA;AA1Bd;AA6BY;EA3CF;;IA4CI,WAAA;EAzBZ;EA2BY;;IACE,sBAAA;IACA,uBAAA;EAxBd;AACF;AA0BY;;EACE,iBAAA;AAvBd;AAyBc;EAHF;;IAII,cAAA;IACA,eAAA;EArBd;AACF;AAwBY;;EACE,0BAAA;AArBd;AAwBY;;EACE,mBAAA;AArBd;AAuBc;;EACE,iBAAA;AApBhB;AAuBc;EAPF;;IAQI,uBAAA;IACA,sBAAA;EAnBd;EAoBc;;IACE,cAAA;IACA,eAAA;EAjBhB;AACF;AAqBU;EACE,aAAA;AAnBZ;AAqBU;EACE,eAAA;EACA,UA3NJ;AAwMR;AAsBU;EACE,yBAAA;EACA,6BAAA;EACA,gCAAA;EACA,UAlOJ;EAmOI,aAAA;EACA,eAAA;EACA,8BAAA;AApBZ;AAsBY;EATF;IAUI,sBAAA;IACA,0BAAA;EAnBZ;EAqBY;IACE,iBAAA;EAnBd;AACF;AAsBY;EACE,gBAAA;AApBd;AAsBc;EAHF;IAII,eAAA;EAnBd;AACF;AAsBY;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AApBd;AAsBc;EALF;IAMI,mBAAA;IACA,8BAAA;IACA,eAAA;EAnBd;AACF;AAqBc;EACE,kBAAA;AAnBhB;AA4BE;EACE,aAAA;EACA,8BAAA;EACA,2BAAA;AA1BJ;AA4BI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AA1BN;AA6BI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AA3BN;AA6BM;EALF;IAMI,sBAAA;EA1BN;AACF;AA4BM;EACE,kBAAA;AA1BR;AA4BQ;EAHF;IAII,eAAA;IACA,kBAAA;EAzBR;AACF;;AA+BA;EACE,uBAAA;EACA,mBAAA;EACA,cAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA5BF;AA8BE;EACE,kBAAA;AA5BJ;;AAgCA;EACE,qBAAA;AA7BF;;AAgCA;EACE,iBAAA;AA7BF;;AAgCA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA7BF;;AAgCA;EACE,WAAA;AA7BF","sourcesContent":["@import \"../../styles/variables\";\n\n$width: 50%;\n$redColor: $DVAG-color-rot;\n.heading {\n  text-align: center;\n  padding: 24px 0 32px 0;\n  max-width: 1200px;\n  margin: 0 auto;\n\n  > ds-text {\n    display: block;\n\n    &:first-of-type {\n      padding-bottom: 16px;\n    }\n  }\n\n  .buttons-header {\n    padding: 0 16px;\n    display: flex;\n    justify-content: space-between;\n\n    @media (max-width: $DVAG-breakpoint-SM) {\n      margin-top: 16px;\n    }\n\n    .button-container {\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n    }\n\n    .zurueck {\n      ds-icon {\n        margin-right: 15px;\n      }\n    }\n\n    .weiter {\n      ds-icon {\n        margin-left: 15px;\n      }\n    }\n  }\n}\n\n.main-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding-bottom: 128px;\n\n  .card-container {\n    padding: 16px;\n    background-color: $DVAG-color-hellgrau-95;\n\n    ds-card {\n      .card-header {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n\n        &.header-vertragsdetails {\n          @media (max-width: $DVAG-breakpoint-SM) {\n            flex-direction: column;\n          }\n        }\n\n        .umstellungsfaehigkeit {\n          display: flex;\n          align-items: center;\n\n          .traffic-light {\n            width: 16px;\n            height: 16px;\n            border-radius: 50px;\n            margin-left: 24px;\n\n            &.traffic-light-green {\n              background: $DVAG-color-gruen;\n            }\n\n            &.traffic-light-red {\n              background: $redColor;\n            }\n\n            &.traffic-light-yellow {\n              background: $DVAG-color-gelb;\n            }\n          }\n        }\n      }\n\n      .card-content {\n        display: flex;\n        flex-direction: column;\n\n        .main-container {\n          display: flex;\n          margin-bottom: 24px;\n          align-items: flex-start;\n\n          &.spinner {\n            justify-content: center;\n            align-items: center;\n            padding: 80px;\n          }\n\n          @media (max-width: $DVAG-breakpoint-SM) {\n            justify-content: space-between;\n\n            &.sparten-container {\n              width: fit-content;\n              align-items: flex-start;\n            }\n\n            &.display-column {\n              flex-direction: column;\n\n              ds-text {\n                margin-bottom: 8px;\n              }\n            }\n          }\n\n          &.user-input {\n            & > ds-text {\n              margin-top: 7px;\n            }\n          }\n\n          &.user-input-big {\n            align-items: center;\n          }\n\n          .col-content,\n          .col-label {\n            width: $width;\n            display: flex;\n\n            &.hinweise {\n              display: flex;\n              flex-direction: column;\n\n              .hinweis {\n                margin-bottom: 8px;\n\n                &:last-child {\n                  margin-bottom: 0px;\n                }\n              }\n            }\n\n            .ewe-content {\n              display: flex;\n              flex-direction: column;\n\n              &.eweText {\n                padding-right: 8px;\n              }\n              .ewe-text-color {\n                @extend .text-color;\n              }\n\n              .ewe-info-btn {\n                margin-top: 8px;\n                display: flex;\n                flex-direction: row;\n                justify-items: center;\n              }\n            }\n            .text-color {\n              color: $redColor;\n            }\n            &.flex-n {\n              align-items: center;\n            }\n\n            @media (max-width: $DVAG-breakpoint-SM) {\n              width: auto;\n\n              &.flex-n {\n                flex-direction: column;\n                align-items: flex-start;\n              }\n            }\n            .flexN-kontostand {\n              margin-left: 16px;\n\n              @media (max-width: $DVAG-breakpoint-SM) {\n                margin-left: 0;\n                margin-top: 8px;\n              }\n            }\n\n            ds-radio-button {\n              padding: 8px 66px 8px 12px;\n            }\n\n            &.minderbeitrag-content {\n              align-items: center;\n\n              .button {\n                margin-left: 20px;\n              }\n\n              @media (max-width: $DVAG-breakpoint-SM) {\n                align-items: flex-start;\n                flex-direction: column;\n                .button {\n                  margin-left: 0;\n                  margin-top: 8px;\n                }\n              }\n            }\n          }\n          .vertragnr-cont {\n            display: flex;\n          }\n          .sparten-label {\n            padding: 14px 0;\n            width: $width;\n          }\n\n          .sparten-content {\n            padding: 0px 0px 14px 0px;\n            border-top: 1px solid $DVAG-color-hellgrau-85;\n            border-bottom: 1px solid $DVAG-color-hellgrau-85;\n            width: $width;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: space-between;\n\n            @media (max-width: $DVAG-breakpoint-MD) {\n              flex-direction: column;\n              padding: 14px 0px 14px 0px;\n\n              .text-top {\n                margin-right: 8px;\n              }\n            }\n\n            &-wrapper {\n              margin-top: 14px;\n\n              @media (max-width: $DVAG-breakpoint-MD) {\n                margin-top: 0px;\n              }\n            }\n\n            div {\n              display: flex;\n              flex-direction: column;\n              align-items: flex-start;\n\n              @media (max-width: $DVAG-breakpoint-MD) {\n                flex-direction: row;\n                justify-content: space-between;\n                margin-top: 0px;\n              }\n\n              .text-top {\n                margin-bottom: 8px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .buttons-container {\n    display: flex;\n    justify-content: space-between;\n    padding: 8px 16px 16px 16px;\n\n    .col-delete {\n      display: flex;\n      align-items: center;\n      margin-left: 24px;\n    }\n\n    .col-buttons {\n      display: flex;\n      align-items: center;\n      margin-right: 24px;\n\n      @media (max-width: $DVAG-breakpoint-SM) {\n        flex-direction: column;\n      }\n\n      .button-secondary {\n        margin-right: 24px;\n\n        @media (max-width: $DVAG-breakpoint-SM) {\n          margin-right: 0;\n          margin-bottom: 8px;\n        }\n      }\n    }\n  }\n}\n\n.main-container.spinner {\n  justify-content: center;\n  align-items: center;\n  padding: 180px;\n}\n\n.error-message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n\n  ds-icon {\n    margin-right: 10px;\n  }\n}\n\n.pre-wrap {\n  white-space: pre-wrap;\n}\n\n.anschreibenInputWrapper {\n  margin: 16px auto;\n}\n\n.anschreibenLineHint {\n  text-align: right;\n  display: block;\n  padding-right: 8px;\n  padding-top: 6px;\n}\n\n.flexN-Input {\n  width: 80px;\n}\n","$DVAG-fontweight-regular: 400;\n$DVAG-fontweight-medium: 500;\n$DVAG-fontweight-bold: 700;\n\n$DVAG-breakpoint-SM: 576px;\n$DVAG-breakpoint-MD: 768px;\n$DVAG-breakpoint-LG: 992px;\n$DVAG-breakpoint-XL: 1200px;\n\n// Primaerfarbe\n$DVAG-color-gold: #a7893d;\n$DVAG-color-gold-dunkel: #856d30;\n$DVAG-color-gold-mittel: #957b36;\n$DVAG-color-gold-hell: #e3dac4;\n\n// Sekundaerfarbe\n$DVAG-color-weiss: #ffffff;\n\n// Grautoene\n$DVAG-color-anthrazit: #424242;\n$DVAG-color-dunkelgrau-30: #4c4c4c;\n$DVAG-color-dunkelgrau-40: #666666;\n$DVAG-color-dunkelgrau-50: #7f7f7f;\n$DVAG-color-dunkelgrau-70: #c1c1c1;\n$DVAG-color-hellgrau-85: #dedede;\n$DVAG-color-hellgrau-90: #ebebeb;\n$DVAG-color-hellgrau-95: #f5f5f5;\n$DVAG-color-hellgrau-98: #979797;\n\n// Gestaltungsfarben\n$DVAG-color-dunkelblau: #004165;\n$DVAG-color-dunkelblau-80: #336783;\n$DVAG-color-dunkelblau-60: #668da2;\n$DVAG-color-dunkelblau-40: #99b3c1;\n$DVAG-color-dunkelblau-20: #ccd9e0;\n\n$DVAG-color-rot: #be1413;\n$DVAG-color-rot-80: #cb4342;\n$DVAG-color-rot-60: #d87271;\n$DVAG-color-rot-40: #e5a1a0;\n$DVAG-color-rot-20: #f2d0cf;\n\n$DVAG-color-petrol: #3b94a3;\n$DVAG-color-petrol-80: #62a9b5;\n$DVAG-color-petrol-60: #89bec7;\n$DVAG-color-petrol-40: #b0d4da;\n$DVAG-color-petrol-20: #d7e9ec;\n\n$DVAG-color-gelb: #e8b50e;\n$DVAG-color-gelb-80: #ecc33e;\n$DVAG-color-gelb-60: #f1d26e;\n$DVAG-color-gelb-40: #f5e19e;\n$DVAG-color-gelb-20: #faf0ce;\n\n$DVAG-color-gruen: #6ea318;\n$DVAG-color-gruen-80: #8bb546;\n$DVAG-color-gruen-60: #a8c774;\n$DVAG-color-gruen-40: #c5daa2;\n$DVAG-color-gruen-20: #e2ecd0;\n\n// Transparenzen\n$DVAG-boxshadow-header: 0px -4px 12px 0px rgba(0, 0, 0, 0.16);\n$DVAG-boxshadow-toolbar: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);\n$DVAG-boxshadow-tooltip: 0px 4px 12px 2px rgba(0, 0, 0, 0.16);\n$DVAG-boxshadow-fehlertooltip: 0px 4px 12px 0px rgba(0, 0, 0, 0.32);\n$DVAG-boxshadow-modal-view: 0px 0px 30px 0px rgba(0, 0, 0, 0.16);\n$DVAG-boxshadow-modal-view-hintergrund: rgba(102, 102, 102, 0.6);\n$DVAG-boxshadow-alert-grundflaeche: rgba(255, 255, 255, 0.5) rgba(252, 252, 252, 0.8);\n\n$spacing: (\n  margin: (\n    m-8: 8px,\n    m-16: 16px,\n    m-24: 24px,\n    m-32: 32px,\n    m-48: 48px,\n    m-64: 64px,\n  ),\n  padding: (\n    p-8: 8px,\n    p-16: 16px,\n    p-24: 24px,\n    p-32: 32px,\n    p-48: 48px,\n    p-64: 64px,\n  ),\n);\n\n$inputBorderRadius: 4px;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
